import React from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { toggleModal } from "./modals";
import { ModalNames, StateProps } from "./state";
import { LoginButton } from "./LoginButton";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AddIcon from "@mui/icons-material/Add";
import ArticleIcon from "@mui/icons-material/Article";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";

const menuItems = [
  // TODO - use router?
  { name: "New Recipe", modalName: ModalNames.NEW_RECIPE },
  { name: "Recipe Book", modalName: ModalNames.RECIPE_BOOK },
  { name: "Settings", modalName: ModalNames.SETTINGS },
];

export interface MenuBarProps extends StateProps {
  readonly setRefreshing: React.Dispatch<React.SetStateAction<boolean>>;
}
export function MenuBar(props: MenuBarProps) {
  const { state, setState } = props;
  const [open, setOpen] = React.useState(false);

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const startIconMap: Record<ModalNames, React.ReactNode> = {
    [ModalNames.NEW_RECIPE]: <AddIcon />,
    [ModalNames.RECIPE_BOOK]: <MenuBookIcon />,
    [ModalNames.SETTINGS]: <SettingsIcon />,
    [ModalNames.RECIPE_CARD]: <ArticleIcon />,
    [ModalNames.CONFIRMATION]: <ThumbUpAltIcon />,
  };

  const menuBarItems = (
    <Box sx={{ display: mobile ? "contents" : "block" }}>
      {localStorage.getItem("authToken") ? (
        menuItems.map((item, index) => (
          <Button
            key={item.name.replaceAll(" ", "-")}
            onClick={() => {
              toggleModal({ setState, name: item.modalName });
            }}
            startIcon={startIconMap[item.modalName]}
            color="inherit"
            sx={{
              ...{
                mx: 1,
                fontWeight: "normal",
              },
              ...(mobile
                ? {
                    paddingTop: index === 0 ? "2em" : "0.75em",
                    paddingLeft: "1em",
                    paddingRight: "1em",
                  }
                : {}),
            }}
          >
            {item.name}
          </Button>
        ))
      ) : (
        <></>
      )}
      {LoginButton({
        ...props,
        ...(mobile
          ? {
              sx: {
                paddingTop: localStorage.getItem("authToken")
                  ? "0.75em"
                  : "2em",
                paddingLeft: "1em",
                paddingRight: "1em",
              },
              startIcon: <LogoutIcon />,
            }
          : {}),
      })}
    </Box>
  );

  return (
    <AppBar position="static" color="default" elevation={1}>
      <Toolbar>
        <Typography
          variant="h6"
          sx={{ flexGrow: 1, color: "primary.main", fontWeight: 700 }}
        >
          shopping list
        </Typography>
        {mobile ? (
          <IconButton color="inherit" onClick={() => setOpen(true)}>
            <MenuIcon />
          </IconButton>
        ) : (
          menuBarItems
        )}
      </Toolbar>
      <Drawer open={open} onClose={() => setOpen(false)} anchor="right">
        {menuBarItems}
      </Drawer>
    </AppBar>
  );
}

export default MenuBar;
